import React from 'react';
import PropTypes, {InferProps} from 'prop-types';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import {NotFound} from 'modules';
import {ModuleItem} from 'commons/types/Types';

/**
 * Routing component
 * @param {InferProps<typeof Routing.propTypes>} props
 * @returns {JSX.Element}
 * @constructor
 */
function Routing(props: InferProps<typeof Routing.propTypes>) {
    const match = useRouteMatch();
    const {routes} = props;

    function submoduleRouter(
        submodule: Array<ModuleItem>,
        key: string
    ): React.ReactNode {
        return submodule.map((submodule: ModuleItem, id: number) => {
            if (submodule.thirdLevel && submodule.items) {
                return submoduleRouter(submodule.items, `${key}-${id}`);
            } else {
                const pathname: string = match.path + submodule.path;
                return (
                    <Route
                        exact={submodule.exact}
                        path={pathname}
                        component={submodule.component}
                        key={`${key}-${id}`}
                    />
                );
            }
        });
    }
    return (
        <Switch>
            {routes.map((item: ModuleItem, key: number) => {
                if (item.items && item.items.length > 0) {
                    return submoduleRouter(item.items, `${key}`);
                } else {
                    const pathname: string = match.path + item.path;
                    return (
                        <Route
                            exact={item.exact}
                            path={pathname}
                            component={item.component}
                            key={key}
                        />
                    );
                }
            })}
            <Route component={NotFound} />
        </Switch>
    );
}

Routing.propTypes = {
    /** Routes to declare paths */
    routes: PropTypes.any,
    dynamicRoutes: PropTypes.any,
};

export default Routing;
